<ng-container
  *ngIf="sessionSharedDataService.changeParticipantsManagerSection | async as activeSection"
>
  <div class="parent-div">
    <div class="title" [style.height.px]="topbarheight$ | async">
      <ng-container *ngIf="!selectedPermission; else selectedPermissionHeader">
        <div class="d-flex align-items-center">
          <app-pencil-icon
            name="people_alt"
            [type]="IconTypes.materialIcon"
            [outlined]="true"
            class="cmr-6"
            style="--pencil-icon-size: 18px"
          >
          </app-pencil-icon>
          <span class="custom-text title-text">
            {{ 'Manage' | translate }}
          </span>
        </div>
      </ng-container>

      <ng-template #selectedPermissionHeader>
        <div class="d-flex align-items-center">
          <mat-icon class="icon cursor-pointer" (click)="selectedPermission = undefined">
            arrow_back
          </mat-icon>
          <span class="cmr-4 fw-6">
            {{ selectedPermission?.name }}
          </span>
        </div>
      </ng-template>

      <button mat-icon-button (click)="closePanel()" data-name="participants-manager-close">
        <span class="material-icons close-icon">close</span>
      </button>
    </div>

    <ng-container
      *ngTemplateOutlet="selectedPermission ? selectedPermissionTemplate : noPermissionTemplate"
    ></ng-container>

    <!--  Buttons sections to cancel or send and update permissions-->
    <ng-container
      *ngIf="
        activeSection === section.PERMISSIONS &&
        (permissionsChanged || securitySectionChanged || (cursorPermissionChanged$ | async))
      "
    >
      <div class="buttons-section">
        <app-pencil-button
          data-name="participants-manager-permissions-cancel"
          class="cancel-action"
          [theme]="PencilButtonThemeEnum.SECONDARY"
          icon="close"
          [iconConfig]="{
            type: IconTypes.matIcon
          }"
          (click)="cancelPermissionUpdate()"
          [label]="'Cancel' | translate"
        >
        </app-pencil-button>
        <app-pencil-button
          data-name="participants-manager-permissions-update"
          class="update-action"
          [theme]="PencilButtonThemeEnum.PRIMARY"
          icon="check"
          [iconConfig]="{
            type: IconTypes.matIcon
          }"
          (click)="sendPermissionUpdates()"
          [label]="'Update' | translate"
        >
        </app-pencil-button>
      </div>
    </ng-container>
  </div>

  <ng-template #selectedPermissionTemplate>
    <div class="participants-list">
      <div class="d-flex align-items-center cpx-16 cpy-12 bg-light">
        <div class="photos">
          <ng-container *ngFor="let user of activeRoomUsers; let i = index">
            <app-profile-photo
              *ngIf="i < 3"
              [user]="usersMap[user._id]"
              [width]="22"
            ></app-profile-photo>
          </ng-container>
          <span class="more-icon" *ngIf="activeRoomUsers.length > 3"
            >+{{ activeRoomUsers.length - 3 }}</span
          >
        </div>
        <span class="flex-1 font-12 cml-8 fw-6"
          >{{ 'Room participants' | translate | uppercase }} ({{ activeRoomUsers.length }})</span
        >
        <mat-checkbox
          class="check-box"
          [checked]="
            (currentPermissions | checkIndeterminatePermission: selectedPermission?.fieldName) ===
            permissionStatus.ENABLED_FOR_ALL
          "
          [indeterminate]="
            (currentPermissions | checkIndeterminatePermission: selectedPermission?.fieldName) ===
            permissionStatus.PARTIAL_ENABLED
          "
          [color]="'primary'"
          (change)="updateEveryonePermission($event, selectedPermission?.fieldName)"
        ></mat-checkbox>
      </div>
      <div *ngFor="let user of activeRoomUsers" class="d-flex align-items-center cpx-16 cpy-12">
        <app-profile-photo [user]="usersMap[user._id]" [width]="34"></app-profile-photo>
        <span class="flex-1 font-14 cml-8 fw-6">{{ usersMap[user._id]?.name }}</span>
        <mat-checkbox
          class="check-box"
          [color]="'primary'"
          [checked]="
            currentPermissions[selectedPermission?.fieldName] | individualUserPermission: user._id
          "
          (change)="updateIndividualPermission($event, user)"
        >
        </mat-checkbox>
      </div>
      <div *ngIf="!activeRoomUsers.length" class="font-12 text-gray text-center cmt-12 fw-6">
        {{ 'This room has no participants' | translate | uppercase }}
      </div>
    </div>
  </ng-template>

  <ng-template #noPermissionTemplate>
    <div class="tabs" id="tabsDiv">
      <nav class="participants-navbar navbar navbar-expand-lg cp-0 d-none d-sm-block">
        <ul class="navbar-nav flex-row">
          <app-participants-manager-nav-item
            attributeDataIntercomTarget="Participants Manager Control"
            attributeDataName="participants-manager-controls"
            [activeSection]="activeSection"
            [relatedSection]="section.CONTROLS"
            [label]="isHost ? ('Controls' | translate) : ('People' | translate)"
            (handleNavItemClick)="openSection(section.CONTROLS)"
          >
          </app-participants-manager-nav-item>

          <app-participants-manager-nav-item
            *ngIf="showQueueTab$ | async"
            attributeDataIntercomTarget="Participants Manager QUEUE"
            attributeDataName="participants-manager-queue"
            [activeSection]="activeSection"
            [relatedSection]="section.QUEUE"
            [label]="'Queue' | translate"
            (handleNavItemClick)="openSection(section.QUEUE)"
          >
            <span class="queue-count-badge">
              <app-count-badge [count]="queueBadgeCount$ | async" [limit]="100"></app-count-badge>
            </span>
          </app-participants-manager-nav-item>

          <app-participants-manager-nav-item
            *ngIf="isHost && (persistentPermissionEnabled$ | async)"
            attributeDataIntercomTarget="Participants Manager Permissions"
            attributeDataName="participants-manager-permissions"
            [activeSection]="activeSection"
            [relatedSection]="section.PERMISSIONS"
            [label]="'Settings' | translate"
            (handleNavItemClick)="openSection(section.PERMISSIONS)"
          >
          </app-participants-manager-nav-item>

          <app-participants-manager-nav-item
            *ngIf="(attendanceManagerService.attendanceFlags$ | async)?.attendanceList && isHost"
            attributeDataIntercomTarget="Participants Manager Attendance"
            attributeDataName="participants-manager-attendance"
            [activeSection]="activeSection"
            [relatedSection]="section.ATTENDANCE"
            [label]="'Events' | translate"
            (handleNavItemClick)="openSection(section.ATTENDANCE)"
            [class.active-event-red-dot]="attendanceManagerService.onGoingEvent$ | async"
            [isLastNavItem]="true"
          >
          </app-participants-manager-nav-item>
        </ul>
      </nav>
    </div>

    <ng-container *ngIf="viewModel$ | async as viewModel">
      <div class="controls" [hidden]="activeSection !== section.CONTROLS">
        <div
          *ngIf="
            isHost &&
            !isCallConnected &&
            areCallFeaturesAvailable &&
            activeSection === section.CONTROLS
          "
          class="join-call-section"
        >
          <!-- host-join-call -->
          <app-panel-start-call
            [infoMessage]="
              (viewModel.inCallUsers?.size ?? 0) > 0
                ? ('Join call to manage audio and video' | translate)
                : ('Start call to manage audio and video' | translate)
            "
            [isOngoingCall]="(viewModel.inCallUsers?.size ?? 0) > 0"
          >
          </app-panel-start-call>
        </div>

        <div class="users-list-section" *ngIf="activeHostUsers.length > 0">
          <div class="section-title custom-text">
            {{ ('HOSTS' | translate) + ' (' + activeHostUsers.length + ')' }}
          </div>

          <ng-container *ngFor="let user of activeHostUsers">
            <ng-container
              *ngTemplateOutlet="
                participantTemplate;
                context: {
                  user: user,
                  userIsHost: true,
                  userDevicesStates: viewModel.userDevicesStates,
                  inCallUsers: viewModel.inCallUsers
                }
              "
            >
            </ng-container>
          </ng-container>
        </div>

        <div class="divider"></div>

        <div class="users-list-section" *ngIf="activeParticipantsUsers.length > 0">
          <div class="section-title custom-text">
            {{ ('PARTICIPANTS' | translate) + ' (' + activeParticipantsUsers.length + ')' }}
          </div>

          <div class="everyone-section" *ngIf="isHost && inCallParticipants > 1">
            <div class="everyone-info">
              <app-users-presence
                [users]="activeParticipantsUsers"
                [maxUsers]="3"
                [avatarWidth]="24"
                othersIconWidth="24px"
                othersIconHeight="24px"
              ></app-users-presence>
              <div class="custom-text Everyone-text">{{ 'Everyone' | translate }}</div>
            </div>

            <div class="everyone-buttons">
              <button
                [appTooltip]="outOfCalltooltip"
                appTooltipPlacement="center-start"
                [appTooltipDisabled]="!(isHost && !isCallConnected)"
                [ngClass]="{ 'disable-mute-button': isHost && !isCallConnected }"
                class="mute-all-button"
                (click)="turnOffDeviceForAllParticipants(deviceEnum.MIC)"
              >
                <mat-icon class="material-icons-outlined btn-icon">mic_off</mat-icon>
                <span class="custom-text mute-all-button-text"> {{ 'Mute all' | translate }}</span>
              </button>
              <button
                class="all-settings-button"
                [matMenuTriggerFor]="allSettings"
                #trigger="matMenuTrigger"
                [class.active]="allSettingsMenuOpen$ | async"
                (menuOpened)="allSettingsMenuOpen$.next(true)"
                (menuClosed)="allSettingsMenuOpen$.next(false)"
              >
                <mat-icon class="material-icons-outlined">more_horiz</mat-icon>
              </button>
            </div>
          </div>

          <ng-container *ngFor="let user of activeParticipantsUsers">
            <ng-container
              *ngTemplateOutlet="
                participantTemplate;
                context: {
                  user: user,
                  userIsHost: false,
                  userDevicesStates: viewModel.userDevicesStates,
                  inCallUsers: viewModel.inCallUsers
                }
              "
            >
            </ng-container>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <div
      class="event-attendance"
      *ngIf="
        (attendanceManagerService.attendanceFlags$ | async)?.attendanceList &&
        activeSection === section.ATTENDANCE &&
        (sessionSharedDataService.rightPanelView | async)?.expanded
      "
    >
      <app-attendance></app-attendance>
    </div>

    <div
      *ngIf="
        activeSection === section.QUEUE &&
        (sessionSharedDataService.rightPanelView | async)?.expanded &&
        (showQueueTab$ | async)
      "
      class="access-requests-body"
    >
      <app-access-requests></app-access-requests>
    </div>

    <div [hidden]="activeSection !== section.PERMISSIONS" *ngIf="isHost" class="permissions">
      <div class="list">
        <div class="items">
          <!-- security section as it is very different from other sections-->
          <ng-container
            *ngIf="
              isRequestAccessEnabled && {
                currentVisibility: selectedVisibility$ | async,
                currentIsWaitingRoomEnabled: selectedWaitingRoom$ | async
              } as viewModel
            "
          >
            <mat-expansion-panel expanded="true" hideToggle="true" #expansionPanel1>
              <mat-expansion-panel-header>
                <mat-panel-title class="section-title">
                  <div class="icon-wrapper">
                    <app-pencil-icon
                      name="security-shield"
                      [type]="IconTypes.svgIcon"
                      style="--pencil-icon-size: 24px"
                    >
                    </app-pencil-icon>
                  </div>
                  {{ 'security' | translate }}
                </mat-panel-title>
                <ng-container
                  *ngTemplateOutlet="expansionIcon; context: { expanded: expansionPanel1.expanded }"
                ></ng-container>
              </mat-expansion-panel-header>
              <div class="text-info section-description">
                {{
                  viewModel.currentVisibility === Visibility.PUBLIC
                    ? ('Adjust who has access to the Space. Users who sign in as ‘Guest’ are always placed in waiting room.'
                      | translate)
                    : ('Adjust who has access to the Space.' | translate)
                }}
              </div>

              <app-participant-manager-settings-item-menu
                [appRestrictVisibilityControl]="spaceRepo.activeSpace$ | async"
                [appRestrictVisibilityControlTooltipPlacement]="'top-end'"
                [appRestrictVisibilityControlTooltipArrow]="'bottom-right'"
                [title]="'Space visibility' | translate"
                [description]="
                  viewModel.currentVisibility === Visibility.PUBLIC
                    ? ('Anyone with link can join' | translate)
                    : ('Only invitees can join' | translate)
                "
                [dropDownMenuLabel]="viewModel.currentVisibility | translate | titlecase"
                [iconConfig]="{
                  type: IconTypes.matIcon
                }"
                [dataName]="'participant-manger-visibility-button'"
                [menu]="visibilityMenuComponent.menu"
                (valueChanged)="changeVisibility($event)"
              ></app-participant-manager-settings-item-menu>
              <app-participant-manager-settings-item-checkbox
                [title]="'Waiting Room' | translate"
                [description]="
                  'Participants will need host approval every time to enter this Space' | translate
                "
                [checked]="viewModel.currentIsWaitingRoomEnabled"
                [disabled]="isWaitingRoomEnforced$ | async"
                [disableCheckboxTooltipContent]="disabledInteractionTooltip"
                [supportIndividualPermissions]="false"
                [dataName]="'participants-manager-permissions-enable-waiting-room'"
                [isCheckboxTooltipDisabled]="(isWaitingRoomEnforced$ | async) === false"
                (checkboxChange)="toggleWaitingRoom($event)"
                class="waiting-room-checkbox"
              >
              </app-participant-manager-settings-item-checkbox>
            </mat-expansion-panel>
          </ng-container>

          <mat-expansion-panel expanded="true" hideToggle="true" #expansionPanelGeneral>
            <mat-expansion-panel-header class="divider-top">
              <mat-panel-title class="section-title">
                <div class="icon-wrapper">
                  <app-pencil-icon
                    name="settings"
                    [type]="IconTypes.materialIcon"
                    style="--pencil-icon-size: 24px"
                    [outlined]="true"
                  >
                  </app-pencil-icon>
                </div>
                {{ 'general' | translate | uppercase }}
              </mat-panel-title>
              <ng-container
                *ngTemplateOutlet="
                  expansionIcon;
                  context: { expanded: expansionPanelGeneral.expanded }
                "
              ></ng-container>
            </mat-expansion-panel-header>

            <div class="text-info section-description">
              {{ 'Adjust default settings for everyone in this Space' | translate }}
            </div>

            <app-participant-manager-settings-item-menu
              *ngIf="selectedCursorsControlLabelAndSubtitle$ | async as state"
              [title]="'Cursors control' | translate"
              [description]="state.subtitle"
              [dropDownMenuLabel]="state.label"
              [iconConfig]="{
                type: IconTypes.matIcon
              }"
              [dataName]="'participant-manger-cursors-control-button'"
              [menu]="cursorsControlMenuComponent"
              [hasBorder]="false"
            ></app-participant-manager-settings-item-menu>
          </mat-expansion-panel>

          <!-- participant controls  section-->
          <mat-expansion-panel expanded="true" hideToggle="true" #expansionPanel2>
            <mat-expansion-panel-header class="divider-top">
              <mat-panel-title class="section-title">
                <div class="icon-wrapper">
                  <app-pencil-icon
                    name="people_outline_dark_gray"
                    [type]="IconTypes.svgIcon"
                    style="--pencil-icon-size: 24px"
                  >
                  </app-pencil-icon>
                </div>
                {{ 'Participant Controls' | translate }}
              </mat-panel-title>
              <ng-container
                *ngTemplateOutlet="expansionIcon; context: { expanded: expansionPanel2.expanded }"
              ></ng-container>
            </mat-expansion-panel-header>
            <div class="text-info section-description">
              {{ 'Adjust what participants can do in this Space' | translate }}
            </div>

            <!-- Child Mode — capability-gated, stored in space.settings -->
            <ng-container *ngIf="featureManagementService.childModeCapabilityEnabled$ | async">
              <div
                class="child-mode-row"
                [class.child-mode-row--highlighted]="childModeRowHighlighted$ | async"
              >
                <div class="child-mode-left">
                  <div class="child-mode-icon-wrapper">
                    <app-pencil-icon
                      name="child_care"
                      [type]="IconTypes.materialIcon"
                      [outlined]="true"
                      style="--pencil-icon-size: 24px"
                    ></app-pencil-icon>
                  </div>
                  <div class="child-mode-text">
                    <div class="child-mode-title">{{ 'Child mode' | translate }}</div>
                    <div class="child-mode-description">
                      {{ 'Participants have limited access to whiteboard tools.' | translate }}
                      <a
                        class="child-mode-learn-more"
                        href="https://helpdesk.pencilspaces.com/en/articles/14171457-how-to-use-child-mode"
                        target="_blank"
                        rel="noopener noreferrer"
                        (click)="$event.stopPropagation()"
                        >{{ 'Learn more' | translate }}</a
                      >
                    </div>
                  </div>
                </div>
                <mat-checkbox
                  [checked]="isChildModeEnabled$ | async"
                  [color]="'primary'"
                  (click)="$event.stopPropagation()"
                  (change)="toggleChildMode($event.checked)"
                  data-name="participants-manager-permissions-enable-child-mode"
                ></mat-checkbox>
              </div>
            </ng-container>

            <ng-container *ngFor="let group of permissionsGroupMetadata">
              <ng-container *ngIf="group.hideForFreeUsers ? isWebViewerCapabilityEnabled : true">
                <div class="section-title section-title-padded section-title-bottom-boarder">
                  <div class="icon-wrapper">
                    <app-pencil-icon
                      [name]="group.icon ?? group.svg"
                      [type]="group.icon ? IconTypes.materialIcon : IconTypes.svgIcon"
                      [outlined]="group.icon"
                      style="--pencil-icon-size: 24px"
                    ></app-pencil-icon>
                  </div>
                  {{ group.name }}
                </div>
                <ng-container *ngFor="let permission of group.permissions; let i = index">
                  <div [hidden]="permission?.hidden" (click)="onPermissionClick(permission)">
                    <app-participant-manager-settings-item-checkbox
                      [checked]="
                        (currentPermissions
                          | checkIndeterminatePermission: permission.fieldName) ===
                        permissionStatus.ENABLED_FOR_ALL
                      "
                      [disabled]="permissionsEnforcedByInstitution[permission?.fieldName] | async"
                      [title]="permission.name"
                      [renderDivider]="i !== group.permissions.length - 1"
                      [indeterminate]="
                        (currentPermissions
                          | checkIndeterminatePermission: permission.fieldName) ===
                        permissionStatus.PARTIAL_ENABLED
                      "
                      [disableCheckboxTooltipContent]="disabledInteractionTooltip"
                      [isCheckboxTooltipDisabled]="
                        (permissionsEnforcedByInstitution[permission?.fieldName] | async) ===
                          null ||
                        (permissionsEnforcedByInstitution[permission?.fieldName] | async) === false
                      "
                      [dataName]="
                        'participants-manager-permissions-enable-{{ permission.dataName }}'
                      "
                      [supportIndividualPermissions]="true"
                      (checkboxChange)="updateEveryonePermission($event, permission?.fieldName)"
                    >
                    </app-participant-manager-settings-item-checkbox>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </mat-expansion-panel>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template
    #participantTemplate
    let-user="user"
    let-userIsHost="userIsHost"
    let-userDevicesStates="userDevicesStates"
    let-inCallUsers="inCallUsers"
  >
    <div class="user-row">
      <app-profile-photo-with-attachments
        class="name"
        [user]="user"
        [isClickEnabled]="false"
        [showName]="true"
        [fontSize]="14"
        [width]="34"
        [showYouWord]="user?._id === currentUser?._id"
        [enableInactivityIndicator]="!userIsHost && isHost"
        [enableTooltips]="true"
        [userStatus]="inCallUsers?.has(user._id) ? OnlineStatus.IN_CALL : OnlineStatus.ONLINE"
        [isUserInCall]="inCallUsers?.has(user._id)"
      ></app-profile-photo-with-attachments>
      <div class="devices">
        <ng-container *ngIf="isCallReady && inCallUsers?.has(user._id) && isHost">
          <button
            [disabled]="participantsManagerService.turnOffMicSent[user._id]"
            *ngIf="userDevicesStates[user._id]?.mic"
            class="state-btn"
            (click)="
              user._id === currentUser?._id
                ? toggleDevice(deviceEnum.MIC)
                : participantsManagerService.turnOffDeviceForParticipant(deviceEnum.MIC, user._id)
            "
          >
            <mat-icon class="material-icons-outlined"> mic_none </mat-icon>
          </button>
          <div *ngIf="!userDevicesStates[user._id]?.mic">
            <button
              *ngIf="user._id === currentUser?._id"
              [disabled]="
                !(originalPermissions.shareAudio | individualUserPermission: user._id) &&
                !userIsHost
              "
              class="state-btn"
              (click)="toggleDevice(deviceEnum.MIC)"
            >
              <svg-icon
                *ngIf="
                  userIsHost ||
                  (originalPermissions.shareAudio | individualUserPermission: user._id)
                "
                [width]="34"
                [height]="34"
                [icon]="'mic-mute-dark'"
              ></svg-icon>
            </button>
            <button
              *ngIf="user._id !== currentUser?._id"
              [disabled]="
                (!(originalPermissions.shareAudio | individualUserPermission: user._id) &&
                  !userIsHost) ||
                !isCallConnected
              "
              class="state-btn"
              [matMenuTriggerFor]="requestMatmenu"
              [matMenuTriggerData]="{ device: deviceEnum.MIC, userId: user._id }"
            >
              <ng-container
                *ngIf="
                  ((originalPermissions.shareAudio | individualUserPermission: user._id) ||
                    userIsHost) &&
                    isCallConnected;
                  then enabledMic;
                  else disabledMic
                "
              ></ng-container>

              <ng-template #enabledMic>
                <svg-icon [width]="34" [height]="34" [icon]="'mic-mute-dark'"></svg-icon>
              </ng-template>

              <ng-template #disabledMic>
                <ng-container
                  *ngIf="
                    !isCallConnected &&
                      !(originalPermissions.shareAudio | individualUserPermission: user._id);
                    then disabledMicCallNotConnected;
                    else callConnectedOrAudioPermission
                  "
                ></ng-container>
              </ng-template>

              <ng-template #callConnectedOrAudioPermission>
                <ng-container
                  *ngIf="!isCallConnected"
                  [ngTemplateOutlet]="disabledMicCallNotConnected"
                ></ng-container>
                <ng-container
                  *ngIf="!(originalPermissions.shareAudio | individualUserPermission: user._id)"
                  [ngTemplateOutlet]="disabledMicCallAudioPermission"
                ></ng-container>
              </ng-template>

              <ng-template #disabledMicCallNotConnected>
                <mat-icon
                  class="material-icons-outlined text-gray"
                  [appTooltip]="micTooltipCallNotConnected"
                  appTooltipPlacement="center-start"
                >
                  mic_none
                </mat-icon>
              </ng-template>

              <ng-template #disabledMicCallAudioPermission>
                <mat-icon
                  class="material-icons-outlined text-gray"
                  [appTooltip]="micTooltipAudioPermission"
                  appTooltipPlacement="center-start"
                >
                  mic_none
                </mat-icon>
              </ng-template>

              <ng-template #micTooltipAudioPermission>
                <app-tooltip
                  [text]="'Permission to turn on mic is disabled.' | translate"
                  [arrow]="'right'"
                >
                </app-tooltip>
              </ng-template>

              <ng-template #micTooltipCallNotConnected>
                <app-tooltip
                  [text]="'You need to be in a call to use this function.' | translate"
                  [arrow]="'right'"
                >
                </app-tooltip>
              </ng-template>
            </button>
          </div>
          <button
            *ngIf="userDevicesStates[user._id]?.cam"
            class="state-btn"
            [disabled]="participantsManagerService.turnOffCamSent[user._id]"
            (click)="
              user._id === currentUser?._id
                ? toggleDevice(deviceEnum.CAM)
                : participantsManagerService.turnOffDeviceForParticipant(deviceEnum.CAM, user._id)
            "
          >
            <mat-icon class="material-icons-outlined"> videocam </mat-icon>
          </button>
          <div *ngIf="!userDevicesStates[user._id]?.cam">
            <button
              *ngIf="user._id === currentUser?._id"
              [disabled]="
                !(originalPermissions.shareVideo | individualUserPermission: user._id) &&
                !userIsHost
              "
              class="state-btn"
              (click)="toggleDevice(deviceEnum.CAM)"
            >
              <svg-icon
                *ngIf="
                  userIsHost ||
                  (originalPermissions.shareVideo | individualUserPermission: user._id)
                "
                [icon]="'vid-no-cam-dark'"
                [width]="34"
                [height]="34"
              ></svg-icon>
            </button>
            <button
              *ngIf="user._id !== currentUser?._id"
              class="state-btn"
              [disabled]="
                (!(originalPermissions.shareVideo | individualUserPermission: user._id) &&
                  !userIsHost) ||
                !isCallConnected
              "
              [matMenuTriggerFor]="requestMatmenu"
              [matMenuTriggerData]="{ device: deviceEnum.CAM, userId: user._id }"
            >
              <ng-container
                *ngIf="
                  ((originalPermissions.shareVideo | individualUserPermission: user._id) ||
                    userIsHost) &&
                    isCallConnected;
                  then enabledCam;
                  else disabledCam
                "
              ></ng-container>
              <ng-template #enabledCam>
                <svg-icon [icon]="'vid-no-cam-dark'" [width]="34" [height]="34"></svg-icon>
              </ng-template>

              <ng-template #disabledCam>
                <ng-container
                  *ngIf="
                    !isCallConnected &&
                      !(originalPermissions.shareVideo | individualUserPermission: user._id);
                    then disabledCamCallNotConnected;
                    else callConnectedOrCamPermission
                  "
                ></ng-container>
              </ng-template>

              <ng-template #callConnectedOrCamPermission>
                <ng-container
                  *ngIf="!isCallConnected"
                  [ngTemplateOutlet]="disabledCamCallNotConnected"
                ></ng-container>
                <ng-container
                  *ngIf="!(originalPermissions.shareVideo | individualUserPermission: user._id)"
                  [ngTemplateOutlet]="disabledCamCallAudioPermission"
                ></ng-container>
              </ng-template>

              <ng-template #disabledCamCallNotConnected>
                <mat-icon
                  class="material-icons-outlined text-gray"
                  [appTooltip]="micTooltipCallNotConnected"
                  appTooltipPlacement="center-start"
                >
                  videocam
                </mat-icon>
              </ng-template>

              <ng-template #disabledCamCallAudioPermission>
                <mat-icon
                  class="material-icons-outlined text-gray"
                  [appTooltip]="camPermissionTooltip"
                  appTooltipPlacement="center-start"
                >
                  videocam
                </mat-icon>
              </ng-template>

              <ng-template #camPermissionTooltip>
                <app-tooltip
                  [text]="'Permission to turn on cam is disabled.' | translate"
                  [arrow]="'right'"
                >
                </app-tooltip>
              </ng-template>

              <ng-template #micTooltipCallNotConnected>
                <app-tooltip
                  [text]="'You need to be in a call to use this function.' | translate"
                  [arrow]="'right'"
                >
                </app-tooltip>
              </ng-template>
            </button>
          </div>
        </ng-container>
        <ng-container
          *ngIf="isHost || (user?._id !== currentUser?._id && (isFollowModeFlagEnabled$ | async))"
        >
          <button
            class="state-btn"
            [matMenuTriggerFor]="
              (screenSizeService.renderMenuAsBottomSheet$ | async)
                ? null
                : actionsMenuComponent.actionsMenu
            "
            (click)="onActionsMenuOpened($event, user)"
            (menuOpened)="userSettingsMenuOpen$.next(true)"
            (menuClosed)="userSettingsMenuOpen$.next(false)"
            [class.active]="
              (userSettingsMenuOpen$ | async) &&
              (selectedUserForActions$ | async)?._id === user?._id
            "
          >
            <mat-icon class="material-icons-outlined"> more_horiz </mat-icon>
          </button>
        </ng-container>
      </div>
    </div>
  </ng-template>
  <ng-template #expansionIcon let-isExpanded="expanded">
    <app-pencil-icon
      name="keyboard_arrow_down"
      [type]="IconTypes.materialIcon"
      style="--pencil-icon-size: 24px"
      *ngIf="!isExpanded"
    >
    </app-pencil-icon>
    <app-pencil-icon
      name="keyboard_arrow_up"
      [type]="IconTypes.materialIcon"
      style="--pencil-icon-size: 24px"
      *ngIf="isExpanded"
    >
    </app-pencil-icon>
  </ng-template>
  <mat-menu #requestMatmenu="matMenu" class="request-menu" (click)="$event.stopPropagation()">
    <ng-template matMenuContent let-device="device" let-userId="userId">
      <div class="title">
        <span class="txt">
          {{ device === 'mic' ? 'Request to unmute' : ('Request to enable camera' | translate) }}
        </span>
        <mat-icon class="material-icons-outlined close-btn">close</mat-icon>
      </div>
      <div class="msg">
        {{
          device === 'mic'
            ? 'Send this participant a request to unmute their microphone'
            : ('Send this participant a request to turn on their video camera.' | translate)
        }}
      </div>
      <button
        *ngIf="
          (device === deviceEnum.MIC && !participantsManagerService.micRequestSent[userId]) ||
          (device === deviceEnum.CAM && !participantsManagerService.camRequestSent[userId])
        "
        class="overflow-btns"
        (click)="$event.stopPropagation(); participantsManagerService.sendRequest(device, userId)"
      >
        <mat-icon class="send-icon">send</mat-icon>
        <span class="text fw-6"> {{ 'Request' | translate }} </span>
      </button>
      <div
        *ngIf="
          !(device === deviceEnum.MIC && !participantsManagerService.micRequestSent[userId]) &&
          !(device === deviceEnum.CAM && !participantsManagerService.camRequestSent[userId])
        "
        class="overflow-btns"
        [class.active]="true"
      >
        <mat-icon class="send-icon">send</mat-icon>
        <span class="text fw-6"> {{ 'Request sent!' | translate }} </span>
      </div>
    </ng-template>
  </mat-menu>

  <mat-menu #allSettings="matMenu" class="all-settings-menu">
    <div class="title">
      {{ 'Everyone' | translate }}
    </div>
    <div class="options">
      <button
        [appTooltip]="'You need to be in a call to use this function.' | translate"
        [appTooltipPlacement]="'center-start'"
        [appTooltipDisabled]="!(isHost && !isCallConnected)"
        [ngClass]="{ 'disable-menu-button': isHost && !isCallConnected }"
        class="button"
        (click)="requestAllParticipantsToTurnOnDevice(deviceEnum.MIC)"
      >
        <mat-icon class="material-icons-outlined icon">mic_none</mat-icon>
        <span class="txt"> {{ 'Request all to unmute' | translate }} </span>
      </button>
      <button
        [appTooltip]="'You need to be in a call to use this function.' | translate"
        [appTooltipPlacement]="'center-start'"
        [appTooltipDisabled]="!(isHost && !isCallConnected)"
        [ngClass]="{ 'disable-menu-button': isHost && !isCallConnected }"
        class="button"
        (click)="turnOffDeviceForAllParticipants(deviceEnum.CAM)"
      >
        <mat-icon class="material-icons-outlined icon">videocam_off</mat-icon>
        <span class="txt"> {{ 'Turn off all video' | translate }} </span>
      </button>
      <button
        [appTooltip]="'You need to be in a call to use this function.' | translate"
        [appTooltipPlacement]="'center-start'"
        [appTooltipDisabled]="!(isHost && !isCallConnected)"
        [ngClass]="{ 'disable-menu-button': isHost && !isCallConnected }"
        class="button"
        (click)="requestAllParticipantsToTurnOnDevice(deviceEnum.CAM)"
      >
        <mat-icon class="material-icons-outlined icon">videocam</mat-icon>
        <span class="txt"> {{ 'Request all to turn on camera' | translate }} </span>
      </button>
    </div>
  </mat-menu>

  <ng-template #outOfCalltooltip>
    <app-tooltip
      [text]="'You need to be in a call to use this function.' | translate"
      [arrow]="'right'"
    >
    </app-tooltip>
  </ng-template>
</ng-container>

<ng-template #disabledInteractionTooltip>
  <app-tooltip
    class="wr-tooltip"
    [text]="'You cannot modify this permission because it is set by your institution' | translate"
    [arrow]="'right'"
    [wrapText]="true"
  >
  </app-tooltip>
</ng-template>

<app-participant-manager-actions-menu
  #actionsMenuComponent
  [selectedUserForActions]="selectedUserForActions$ | async"
  [isCurrentUserHost]="isHost"
  [currentUser]="currentUser"
  [openMenuAsBottomSheet]="openActionsMenuAsBottomSheet$ | async"
>
</app-participant-manager-actions-menu>
<app-visibility-menu
  #visibilityMenuComponent
  [dataName]="'participant-manger-visibility-menu-'"
  [selectedValue]="selectedVisibility$ | async"
  (valueChanged)="changeVisibility($event)"
></app-visibility-menu>
<mat-menu class="pencil-mat-menu light-scheme" #cursorsControlMenuComponent>
  <app-cursor-control-menu
    [currentCursorsControl]="spaceCursorsPermission$ | async"
    (cursorChange)="changeCursorsControl($event)"
  ></app-cursor-control-menu>
</mat-menu>
